<template>
    <div class="sopList-module">
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机/会员卡号"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex flex-y-center flex-start" v-if="this.postId == 1||this.postId == '1472787652026765367'">
            <div class="select-item flex-between flex-y-center" @click="selectTimePopup">
                <div class="select-tit">{{ dateTxt }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" finished-text="没有更多了" @refresh="onRefresh">
            <div class="main-box">
                <div class="top-box flex flex-between flex-y-center"
                    v-if="this.postId == 1||this.postId == '1472787652026765367'">
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{ sopData.notDone }}</div>
                        <div class="top-tit">待完成</div>
                        <div class="top-sign blue"></div>
                    </div>
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{ sopData.finished }}</div>
                        <div class="top-tit">已完成</div>
                        <div class="top-sign green"></div>
                    </div>
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{ sopData.finishedRate }}%</div>
                        <div class="top-tit">完成率</div>
                        <div class="top-sign yellow"></div>
                    </div>
                </div>
                <div class="list-box">
                    <div class="title flex flex-between ">
                        <div class="bold">SOP待办</div>
                        <div class="select-item flex-between flex-y-center" @click="selectTypePopup">
                            <div class="select-tit">{{ checkedType && checkedType.name }}</div>
                            <van-icon name="play" class="select-arrow" />
                        </div>
                    </div>
                    <!-- 下拉刷新 -->
                    <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getSopList"
                        :offset="20" :immediate-check="false">
                        <div class="list-item" v-for="item, index in sopList" :key="index">
                            <div @click="toSopDetail(item.id)">
                                <div class="list-inner flex-y-center ">
                                    <div class="flex-1 list-tit">{{ item.name }}&nbsp;&nbsp;<span
                                            style="color: #A0ACB5;">{{ item.schedule }}%</span>
                                    </div>
                                    <div class="list-num">已完成{{ item.finished }} 待完成{{ item.notDone }}</div>
                                </div>
                                <div class="list-txt">{{ item.content }}</div>
                                <van-progress class="list-rate-box" :percentage="item.schedule" :show-pivot="false"
                                    :color="`${item.e < 50 ? '#ee0a24' : '#2FD0D5'}`" track-color="#fff" />
                                <div class="list-end-time">截止：{{ item.endDate }}</div>

                            </div>
                        </div>
                    </van-list>
                </div>
            </div>
        </van-pull-refresh>
        <van-popup v-model="showTimePopup" round position="bottom" closeable class="popup">
            <date-picker v-model="dateType" @submit="handleDate" :pickerType="pickerType"></date-picker>
        </van-popup>
        <van-popup v-model="showTypePopup" round position="bottom" closeable class="popup">
            <picker title="完成状态" v-model="checkedType" :list="typeList" @change="onTypeChange"></picker>
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from 'vant'
import Picker from '@/components/Picker';
import DatePicker, { getDateText, getFormatTime, PICKER_TYPE } from '@/components/DatePicker';
import { keepAliveAfterHandler } from "@/router/router";
const TYPE_LIST = [{ id: 1, name: '已确认' },
{ id: 2, name: '待确认' },]

export default {
    name: 'sopList',
    components: {
        DatePicker, Picker
    },
    beforeRouteLeave(to, from, next) {
        keepAliveAfterHandler.call(this, to, from)
        next()
    },
    data() {
        return {
            pickerType: PICKER_TYPE.MONTH,// 日期控件类型
            dateType: '2', // 日期
            beginMonth: '', // 开始日期
            endMonth: '', // 结束日期
            searchStr: '',  // 搜索条件
            typeList: TYPE_LIST,
            page: 1,
            total: 0,
            limit: 10,       //每页条数
            loading: false,    //加载
            finished: false,    //结束加载
            refreshing: false,   //刷新
            sopList: [],//sop列表
            sopData: {},//sop数据
            showTimePopup: false,//选择时间弹窗
            showTypePopup: false,//选择状态
            checkedType: TYPE_LIST[1],//所选状态
            postId: 0//权限
        }
    },
    computed: {
        dateTxt() {
            return getDateText(this.dateType, this.beginMonth, this.endMonth, this.pickerType)
        }
    },
    mounted() {
        this.getSopList();
        this.getSopData();
        this.postId = localStorage.getItem('postId') || getCookie('postId')
    },
    methods: {
        // 获取列表
        getSopList() {
            const beginDate = getFormatTime(this.beginMonth, this.pickerType)
            const endDate = getFormatTime(this.endMonth, this.pickerType)
            request({
                url: `/workContactSop/page?page=${this.page}&limit=10&dateType=${this.dateType}&beginMonth=${beginDate}
                &endMonth=${endDate}&name=${this.searchStr}&type=${this.checkedType.id}`,
                method: "get",
            })
                .then((res) => {
                    this.sopList = this.page == 1 ? res.data.list : this.sopList.concat(res.data.list);
                    this.total = res.data.total;
                    this.page += 1;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    if (this.sopList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        getSopData() {
            const beginDate = getFormatTime(this.beginMonth, this.pickerType)
            const endDate = getFormatTime(this.endMonth, this.pickerType)
            request({
                url: `/workContactSop/sopData?dateType=${this.dateType}&beginMonth=${beginDate}
                &endMonth=${endDate}`,
                method: "get",
            })
                .then((res) => {
                    this.sopData = res.data
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        //搜索
        onSearch() {
            this.page = 1
            this.getSopData();

        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.onRefresh()
        },
        // 弹窗
        selectTimePopup() {
            this.showTimePopup = true
        },
        selectTypePopup() {
            this.showTypePopup = true
        },
        // 筛选相关
        handleDate(id, begin, end) {
            this.showTimePopup = false
            this.dateType = id
            if (!id) {
                this.beginMonth = begin
                this.endMonth = end
            } else {
                this.beginMonth = ''
                this.endMonth = ''
            }
            this.onRefresh()
        },
        onTypeChange(data) {
            this.showTypePopup = false
            this.checkedType = data
            this.onRefresh()
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.sopData = {};
            this.sopList = [];
            this.refreshing = false;
            this.getSopList();
            this.getSopData();
        },
        toSopDetail(id) {
            this.$router.push({ name: "sopDetail", query: { id } });
        }
    },
}
</script>

<style scoped lang="less">
.ml-20 {
    margin-left: 20px;
}

::-webkit-scrollbar {
    display: none;
}

.sopList-module {
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;
}

.select-box {
    padding: 20px 30px 20px 30px;
}

.select-tit {
    font-size: 28px;
    color: #35434c;
}

.select-arrow {
    transform: rotate(90deg);
    font-size: 24px;
    margin-left: 10px;
}

.main-box {
    padding: 30px 30px;
}

.top-box {
    margin-bottom: 50px;

    .top-item {
        width: 200px;
        height: 128px;
        background: #ffffff;
        box-shadow: 4px 5px 20px 0px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        position: relative;
        justify-content: center;
        overflow: hidden;
    }

    .top-num {
        font-size: 36px;
        font-weight: 700;
        color: #35434c;
    }

    .top-tit {
        font-size: 26px;
        font-weight: 400;
        color: #a0acb5;
    }

    .top-sign {
        position: absolute;
        right: -25px;
        bottom: -25px;
        width: 70px;
        height: 70px;
        border-radius: 50%;
    }

    .top-sign.blue {
        background: #4a6be6;
    }

    .top-sign.green {
        background: #4bca85;
    }

    .top-sign.yellow {
        background: #f3d168;
    }
}

.list-box {
    min-height: calc(100vh - 400px);

    padding-bottom: 50px;
    height: 100%;

    .title {
        font-size: 34px;
        color: #35434c;
        margin-bottom: 40px;
    }

    .list-item {
        width: 690px;
        min-height: 250px;
        background: #fafafe;
        border-radius: 10px;
        padding: 30px 20px;
        margin-bottom: 20px;

        .list-inner {
            width: 100%;
            margin-bottom: 18px;
        }

        .list-icon {
            width: 50px;
            max-height: 50px;
            margin-right: 25px;
        }

        .list-tit {
            font-size: 30px;
            font-weight: 400;
            color: #35434c;
        }

        .list-num {
            font-size: 26px;
            font-weight: 400;
            color: #35434c;
        }

        .list-txt {
            font-size: 26px;
            color: #66757f;
            margin-bottom: 22px;
        }

        .list-rate-box {
            width: 650px;
        }

        .list-end-time {
            margin-top: 20px;
            font-size: 26px;
            font-weight: 400;
            color: #a0acb5;
            text-align: right;
        }
    }
}

.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}

.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}

:deep(.van-popup__close-icon--top-right) {
    top: 50px;
}

:deep(.search-button .van-icon) {
    font-size: 28px;
}

:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 8px 20px 0 20px !important;
    margin-right: 0 !important;
}

:deep(.search-button .van-search__content) {
    padding-left: 0 !important;
}

:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>
